import { Tooltip } from "@mui/material";
import React, { ReactElement, ReactNode } from "react";

interface PaneTooltipProps {
  title: ReactNode;
  children: ReactElement;
  /** Overrides the default hover delay. */
  enterDelay?: number;
}

const ENTER_DELAY_MS = 1500;

/** For icons that exist to be read: they are aimed at deliberately, so waiting reads as broken. */
export const INFO_TOOLTIP_DELAY_MS = 100;

/**
 * Tooltip for use inside the task pane. The pane is too narrow for side placement, so the text
 * sits above its trigger and is kept inside the pane at any width.
 */
const PaneTooltip = ({ title, children, enterDelay = ENTER_DELAY_MS }: PaneTooltipProps) => (
  <Tooltip
    title={title}
    arrow
    placement="top"
    enterDelay={enterDelay}
    // Without a matching enterNextDelay, once one tooltip has opened the rest follow instantly, so
    // sweeping a card's row of icon buttons still flashes every label.
    enterNextDelay={enterDelay}
    slotProps={{
      tooltip: { sx: { fontSize: "12px" } },
      popper: {
        modifiers: [
          { name: "offset", options: { offset: [0, 8] } },
          { name: "preventOverflow", options: { padding: 18 } },
          { name: "flip", options: { padding: 18 } },
        ],
      },
    }}
  >
    {children}
  </Tooltip>
);

export default PaneTooltip;
